import { useState, useEffect } from 'react';
import { Modal, Button } from '@components/ui';
import { imalatDurumlari } from '@mocks/materials/cati';

export default function ImalatModal({ isOpen, onClose, onSubmit, data, isLoading = false }) {
    const [imalatYuzde, setImalatYuzde] = useState(0);
    const [imalatDurumu, setImalatDurumu] = useState('');
    const [not, setNot] = useState('');

    useEffect(() => {
        if (data) { setImalatYuzde(data.imalatYuzde || 0); setImalatDurumu(data.imalatDurumu || 'bekliyor'); }
    }, [data]);

    const handleChange = (val) => {
        const y = Math.min(100, Math.max(0, parseInt(val) || 0));
        setImalatYuzde(y);
        if (y >= 100) setImalatDurumu('tamamlandi');
        else if (y > 0) setImalatDurumu('devam');
    };

    const handleSubmit = () => { onSubmit({ imalatYuzde, imalatDurumu, not }); };

    if (!data) return null;
    const inputClass = "w-full px-3 py-2.5 bg-bg-primary border border-border-light rounded-lg text-sm text-text-primary focus:outline-none focus:ring-2 focus:ring-primary/50";

    return (
        <Modal isOpen={isOpen} onClose={onClose} title="İmalat Güncelle" size="sm"
            footer={<><Button variant="ghost" onClick={onClose} disabled={isLoading}>İptal</Button><Button variant="success" onClick={handleSubmit} isLoading={isLoading}>Güncelle</Button></>}>
            <div className="space-y-4">
                <div className="p-3 bg-bg-tertiary rounded-lg">
                    <p className="font-medium text-text-primary">{data.urunAdi}</p>
                    <p className="text-sm text-text-muted">{data.aciklama}</p>
                </div>
                <div>
                    <label className="block text-sm font-medium text-text-primary mb-1.5">İmalat (%)</label>
                    <input type="range" min={0} max={100} value={imalatYuzde} onChange={(e) => handleChange(e.target.value)} className="w-full h-2 bg-bg-tertiary rounded-lg appearance-none cursor-pointer accent-success" />
                    <div className="flex justify-between mt-1">
                        <input type="number" min={0} max={100} value={imalatYuzde} onChange={(e) => handleChange(e.target.value)} className="w-20 px-2 py-1 bg-bg-primary border border-border-light rounded text-sm text-center" />
                        <span className={`text-sm font-medium ${imalatYuzde >= 100 ? 'text-success' : 'text-warning'}`}>%{imalatYuzde}</span>
                    </div>
                </div>
                <div><label className="block text-sm font-medium text-text-primary mb-1.5">İmalat Durumu</label>
                    <select value={imalatDurumu} onChange={(e) => setImalatDurumu(e.target.value)} className={inputClass}>{imalatDurumlari.map(m => <option key={m.key} value={m.key}>{m.label}</option>)}</select></div>
                <div><label className="block text-sm font-medium text-text-primary mb-1.5">Not</label>
                    <input type="text" value={not} onChange={(e) => setNot(e.target.value)} placeholder="İmalat notu..." className={inputClass} /></div>
            </div>
        </Modal>
    );
}
